export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13295.092b757d.jpg";